import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const FilterChipsWrapper = styled(Box)`
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
  align-items: center;
  gap: ${theme.spacing.md}px;
  width: calc(100% - 24px); /* Reserve 24px gap for controls on the right */
  margin-right: 24px; /* 24px gap before the controls */
`
